import { createContext, useContext } from 'react';

/**
 * Context providing tooltip state to its children.
 */ const TooltipContext = createContext(null);
/**
 * Provider for {@link TooltipContext}.
 */ const TooltipProvider = TooltipContext.Provider;
/**
 * Hook to access the {@link TooltipContext} value.
 */ const useTooltipContext = ()=>useContext(TooltipContext);

export { TooltipContext, TooltipProvider, useTooltipContext };
//# sourceMappingURL=tooltip-context.js.map
